import React from 'react';
import { Redirect } from 'react-router-dom';

// Material UI
import Grid from '@material-ui/core/Grid';

// Components
import FullPageLayout from '../_layout/FullPageLayout/full-page.layout';
import { ManageEvaluationsGraphQL } from '../../Score/ManageEvaluations/manage-evaluations.graphql';
import LoadingPage from '../_boilerplate/LoadingPage/loading-page.container';
import { hasScoringAccess } from '../../../lib/services/scoring.service';
import { HOME_ROUTE } from '../../../../_configuration';

interface IEvaluatePage {
  match: any;
}

export const EvaluatePage: React.FC<IEvaluatePage> = ({ match }) => {
  const { assessmentSessionId } = match.params;
  const { hasScoring, loading } = hasScoringAccess();

  if (loading) return <LoadingPage />;
  if (!hasScoring) return <Redirect to={HOME_ROUTE} />;

  return (
    <FullPageLayout>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ManageEvaluationsGraphQL assessmentSessionId={assessmentSessionId} />
        </Grid>
      </Grid>
    </FullPageLayout>
  );
};
